<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.5057 4.06448L12 12.1225L3.49431 4.06448C3.65583 4.0224 3.8253 4 4 4H20C20.1747 4 20.3442 4.0224 20.5057 4.06448Z"
      :fill="color"
    />
    <path
      d="M21.9293 5.47084L12 14.8775L2.07075 5.47084C2.02463 5.63939 2 5.81682 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 5.81682 21.9754 5.63939 21.9293 5.47084Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'MessageInboxIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
